export default __webpack_public_path__ + "static/media/dominican-republic-beach.d7a04a7d.jpg";